<template>
    <div>
        System status is "<strong>{{ $_.get(activity, "payload.status") ? "Online" : "Offline" }} </strong>".
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "SystemStatusChanged",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
